import { Avatar } from "@mui/material";
import type { CSSProperties } from "@mui/system/CSSProperties";
import { DeleteForeverOutlined, EditOutlined } from "@mui/icons-material";
import { styled } from "@mui/system";
import { Component } from "react";
import image from "../../../assets/images/image.png";
import DeliveraItem from "../../../controller/model/delivera/DeliveraItem";
import { DeliveraStore } from "../../../controller/model/delivera/DeliveraStore";
import Environment from "../../../utils/Environement";

interface PropsInterface {
  item: DeliveraItem;
  onSelect: (item: DeliveraItem) => void;
}

export default class ItemCategoryComponent extends Component {
  public props: PropsInterface;

  constructor(props: any) {
    super(props);
    this.props = props;
    this.handleSelectItem = this.handleSelectItem.bind(this);
  }

  componentDidMount() { }

  componentWillUnmount() { }

  render() {
    return (
      <CardStyle
        onClick={this.handleSelectItem}
        key={`${this.props.item.id}_${new Date().toISOString()}`}
      >
        <div
          style={{
            width: "25%",
            marginRight: "12px",
          }}
        >
          <div style={divImgStyle}>
            {this.props.item.image_url ? (
              <img
                style={imgStyle}
                src={this.props.item.image_url}
                alt="produits"
              />
            ) : (
                <img
                  alt="pic"
                  src={image}
                  style={{ width: "100%", backgroundColor: (Environment.isPopina) ? "#7ABF92" : "##ffd400" }}
                />
              )}
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            width: "70%",
          }}
        >
          <div style={{ fontWeight: 600, fontSize: "17px", textAlign: "left" }}>
            {DeliveraStore.retreiveNameFromTranslation(this.props.item.title)}
          </div>

          <span
            style={{
              fontSize: "30px",
              fontWeight: "bold",

              marginBottom: "-15px",
              textAlign: "left",
            }}
          >
            -
          </span>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                fontWeight: 600,
                fontSize: "17px",
              }}
            >
              {`${(this.props.item.price_info.price / 100).toFixed(2)} €`}
            </div>

            <div
              style={{
                alignSelf: "flex-end",
                textAlign: "right",
                display: "flex",
              }}
            >
              <Avatar
                style={{
                  color: (Environment.isPopina) ? "#7abf92" : "#ffd400",
                  backgroundColor: "#fff",
                  border: (Environment.isPopina) ? "1px solid #7abf92" : "1px solid #ffd400",
                  marginLeft: "10px",
                  width: "28px",
                  height: "28px",
                }}
              >
                <EditOutlined />
              </Avatar>
              <Avatar
                style={{
                  color: (Environment.isPopina) ? "#7abf92" : "#ffd400",
                  backgroundColor: "#fff",
                  border: (Environment.isPopina) ? "1px solid #7abf92" : "1px solid #ffd400",
                  marginLeft: "10px",
                  width: "28px",
                  height: "28px",
                }}
              >
                <DeleteForeverOutlined />
              </Avatar>
            </div>
          </div>
        </div>
      </CardStyle>
    );
  }

  private handleSelectItem(event: any) {
    this.props.onSelect(this.props.item);
  }
}

const divImgStyle: CSSProperties = {
  borderRadius: "3px",
  display: "flex",
  width: "64px",
  height: "64px",
  overflow: "hidden",
  position: "relative",
};

const imgStyle = {
  margin: 0,
  padding: 0,
  border: 0,
  fontSize: "100%",
  font: "inherit",
  verticalAlign: "baseline",
  width: "64px",
  height: "64px",
};

const CardStyle = styled('div')({
    color: "#474F5E",
    border: (Environment.isPopina) ? "1px solid #7abf92" : "1px solid #ffd400",
    borderRadius: "3px",
    backgroundColor: "white",
    display: "flex",
    alignItems: "stretch",
    padding: "8px",
    cursor: "pointer",
    margin: "16px 10px",
    Height: "200px",
    textTransform: "capitalize",
    maxWidth: "30%",
    minWidth: "30%",
    "&:hover": {
      borderColor: "#474F5E",
      color: (Environment.isPopina) ? "#7ABF92" : "#ffd400",
      backgroundColor: "#474F5E",
    },
});
